import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../services/app.service';

@Injectable()
export class AdminGuard  {
  constructor(private appService: AppService, private router: Router) {}

  canActivate(): boolean | Promise<boolean> {
    if (this.appService.isAppLoaded) {
      if (this.appService.appUser && this.appService.appUser.IsAdmin) {
        return true;
      } else {
        this.router.navigate(['/']);
        return false;
      }
    } else {
      return new Promise<boolean>((resolve) => {
        this.appService.appLoadedEvent.subscribe(() => {
          if (this.appService.appUser && this.appService.appUser.IsAdmin) {
            resolve(true);
          } else {
            this.router.navigate(['/']);
            resolve(false);
          }
        });
      });
    }
  }
}
